import type { AsyncActionButtonProps } from '@blueshift-ui/inputs';
import type { ClientAdapter } from '@blueshift-ui/fetch/dist/types';

import AsyncActionButton from '@blueshift-ui/inputs/dist/components/async-action-button';
import { TrackedButton } from '@blueshift-ui/analytics';
import useAxiosClient from '@blueshift-ui/fetch/dist/hooks/use-axios-client';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

interface RevertTransformationParams {
  axios: ClientAdapter;
  subscriptionId: string;
  transformationId: string;
}

async function _revertTransformation({
  axios,
  transformationId,
  subscriptionId,
}: RevertTransformationParams) {
  return await axios.makeRequest({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
    url: `/v1/subscriptions/${subscriptionId}/transformations/${transformationId}`,
  });
}

interface RevertUpdateProps extends Partial<AsyncActionButtonProps> {
  onRejected?: () => void;
  onResolved?: () => void;
  revertText?: string;
  subscriptionId: string;
  transformationId: string;
}

function RevertUpdateButton({
  revertText,
  subscriptionId,
  transformationId,
  ...buttonProps
}: RevertUpdateProps) {
  const axios = useAxiosClient();

  const { loading: loadingTranslation, translate } = useTranslation('update_membership');

  async function handleClick() {
    await _revertTransformation({ axios, subscriptionId, transformationId });
  }

  if (loadingTranslation) {
    return null;
  }

  return (
    <AsyncActionButton
      {...buttonProps}
      action={handleClick}
      component={TrackedButton}
      id="revert_membership_plan_confirm_button"
    >
      {revertText || translate('revert_cta')}
    </AsyncActionButton>
  );
}

export default RevertUpdateButton;
